// Shared by the people and companies merge pages. The server copies nothing for a field mapped to null and then
// destroys the originals, so every field the page sends must name a record to copy from.

// What a row compares. Blank (or whitespace-only) text and empty lists count as no value.
function comparable(value) {
  if (Array.isArray(value)) return value.length > 0 ? JSON.stringify(value) : '';
  if (typeof value === 'string') return value.trim();
  return value ?? '';
}

const byKey = key => record => record[key];

// A row is listed only when the records disagree. valueOf is what the row compares, when that isn't record[key].
export function valuesDiffer(records, key, valueOf = byKey(key)) {
  return new Set(records.map(record => comparable(valueOf(record)))).size > 1;
}

// The record a row starts on: the first that has a value, so leaving it unpicked keeps that value. Identical values
// start on the first record, the same as the merge would take them.
export function defaultPick(records, key, valueOf = byKey(key)) {
  return (records.find(record => comparable(valueOf(record)) !== '') || records[0]).id;
}

// Every field starts picked, listed or not, so the request never maps one to null. picks overrides the default for
// the rows whose value isn't record[key].
export function defaultKeys(records, keys, picks = {}) {
  return keys.reduce((defaults, key) => (
    { ...defaults, [key]: picks[key] ? picks[key](records) : defaultPick(records, key) }
  ), {});
}

// Whether a header's "select all" box is checked: only when the record is picked on every listed row, and never with
// nothing listed.
export function allListedOn(keys, listedKeys, id) {
  return listedKeys.length > 0 && listedKeys.every(key => keys[key] === id);
}
